import { lazyComponent } from '@/components/common/utils/lazyImport';

export const LazyCopilotControl = lazyComponent(
  () => import(/* webpackChunkName: 'CopilotControl' */ './CopilotControl'),
  { preload: true },
);
